import { Star, ShoppingCart } from "lucide-react";
import { BOOK, SITE, IMAGES } from "../mock/mock";
import useReveal from "../hooks/useReveal";

export default function BookFeature() {
  const [ref, inView] = useReveal();

  return (
    <section id="livre" className="bg-[#f7f4f6] py-16 md:py-24">
      <div
        ref={ref}
        className={`max-w-5xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-10 md:gap-14 items-center ${inView ? "reveal in-view" : "reveal"}`}
      >
        <div className="flex justify-center">
          <img
            src={IMAGES.bookCover3d}
            alt="Le livre Marcher pour apprendre à aimer"
            loading="lazy"
            decoding="async"
            className="w-64 md:w-80 drop-shadow-[0_30px_60px_rgba(92,39,81,0.35)]"
          />
        </div>

        <div className="text-center md:text-left">
          <p className="font-heading text-xl md:text-2xl font-bold italic text-[#5c2751]">
            {BOOK.pullQuote}
          </p>

          <div className="mt-6 flex items-center gap-3 justify-center md:justify-start">
            <span className="font-heading text-5xl font-extrabold text-[#5c2751] leading-none">
              {BOOK.rating}
            </span>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star
                  key={i}
                  className={`h-5 w-5 ${i <= Math.round(BOOK.rating) ? "fill-[#f5a623] text-[#f5a623]" : "text-gray-300"}`}
                />
              ))}
            </div>
          </div>
          <p className="mt-2 text-sm text-[#6c6c6c]">{BOOK.ratingLabel}</p>

          <p className="mt-6 text-[15px] leading-relaxed text-[#6c6c6c]">
            {BOOK.description}
          </p>
          <p className="mt-3 text-sm font-semibold text-[#5c2751]">{BOOK.editor}</p>

          <a href={SITE.amazonUrl} target="_blank" rel="noopener noreferrer">
            <button
              data-testid="book-buy-btn"
              className="mt-7 inline-flex items-center justify-center gap-2 rounded-full bg-[#5c2751] px-8 py-3.5 text-sm font-semibold text-white hover:bg-[#4a1f42] transition-colors"
            >
              <ShoppingCart className="h-4 w-4" /> Acheter le livre
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}
